import { get } from 'lodash';
import Util from 'client/util/Util';

export default {
  computed: {
    detailObject() {
      return Util.tryParseJson(get(this.policyStatus, 'detail'));
    },

  },
};
